import api from '../../plugins/api';

const signAllDocumentsInDealByType = async ({ dealId, userId, documentTypeId }) => {
  return api.get('/api/bmg/approveProccess', { dealId, userId, documentTypeId });
};

export default signAllDocumentsInDealByType;
